var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.819,
    height: 14.803,
    viewBox: "0 0 14.819 14.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "partager",
    d: "M11.913,9.046a2.874,2.874,0,0,0-2.368,1.248L5.531,8.481a2.821,2.821,0,0,0,0-2.151L9.543,4.508a2.874,2.874,0,1,0-.51-1.63,2.857,2.857,0,0,0,.049.485L4.821,5.3A2.879,2.879,0,1,0,4.812,9.51l4.273,1.929a2.921,2.921,0,0,0-.049.484,2.878,2.878,0,1,0,2.878-2.878Zm0-7.812a1.645,1.645,0,1,1-1.644,1.645,1.645,1.645,0,0,1,1.644-1.645ZM2.868,9.046A1.645,1.645,0,1,1,4.512,7.4,1.645,1.645,0,0,1,2.868,9.046Zm9.045,4.523a1.645,1.645,0,1,1,1.645-1.645,1.645,1.645,0,0,1-1.645,1.645Z",
    transform: "translate(0.026 0.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartager);
export default __webpack_public_path__ + "static/media/partager.608f0f64d2cc16dfa47bf53b0ad21080.svg";
export { ForwardRef as ReactComponent };